import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const Navigation = () => {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  // Define tabs based on user role
  const getTabsForRole = (role) => {
    const baseTabs = [
      { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/dashboard' }
    ];

    if (role === 'admin') {
      return [
        ...baseTabs,
        { id: 'students', label: 'Students', icon: '👥', path: '/add-student' },
        { id: 'staff', label: 'Staff', icon: '👨‍🏫', path: '/add-staff' },
        { id: 'modules', label: 'Modules', icon: '📚', path: '/add-module' },
        { id: 'classes', label: 'Classes', icon: '🎓', path: '/classes' },
        { id: 'profile', label: 'Profile', icon: '👤', path: '/profile' }
      ];
    } else if (role === 'lecturer') {
      return [
        ...baseTabs,
        { id: 'classes', label: 'Classes', icon: '🎓', path: '/classes' },
        { id: 'attendance', label: 'Attendance', icon: '✅', path: '/attendance' },
        { id: 'profile', label: 'Profile', icon: '👤', path: '/profile' }
      ];
    } else if (role === 'student') {
      return [
        ...baseTabs,
        { id: 'attendance', label: 'My Attendance', icon: '✅', path: '/attendance' },
        { id: 'profile', label: 'Profile', icon: '👤', path: '/profile' }
      ];
    }

    return baseTabs;
  };

  const tabs = getTabsForRole(user?.role);

  const handleTabClick = (tab) => {
    setActiveTab(tab.id);
    window.location.href = tab.path;
  };

  return (
    <div style={{ 
      backgroundColor: '#2c3e50', 
      padding: '0 20px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Logo/Brand */}
        <div style={{ 
          color: 'white', 
          fontSize: '20px', 
          fontWeight: 'bold',
          padding: '15px 0'
        }}>
          AttendanceApp
        </div>

        {/* Navigation Tabs */}
        <div style={{ display: 'flex', gap: '0' }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab)}
              style={{
                background: activeTab === tab.id ? '#34495e' : 'transparent',
                color: 'white',
                border: 'none',
                padding: '15px 20px',
                cursor: 'pointer',
                fontSize: '14px',
                borderRadius: '0',
                transition: 'background-color 0.3s',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
              onMouseEnter={(e) => {
                if (activeTab !== tab.id) {
                  e.target.style.backgroundColor = '#34495e';
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== tab.id) {
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              <span>{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        {/* User Info & Logout */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <div style={{ color: 'white', fontSize: '14px' }}>
            <div>{user?.name}</div>
            <div style={{ fontSize: '12px', opacity: 0.8 }}>
              {user?.role?.charAt(0).toUpperCase() + user?.role?.slice(1)}
            </div>
          </div>
          <button
            onClick={logout}
            style={{
              background: '#e74c3c',
              color: 'white',
              border: 'none',
              padding: '8px 15px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navigation;